import {
  CLUSTER_FILTER,
  FILTER_PARAM,
  LIST_USER,
  FILTER_LICENSE,
  LICENSE_BY_FLEET,
  LIST_VEHICLE_CLUSTER,
  SUBSCRIBE_VEHICLE,
  UNSUBSCRIBE_VEHICLE,
  FILTER_LIC_VIN_IMEI,
  PLAYBACK,
  GET_VEHICLE_TRIP,
  GET_ONE_MW_MAPPING,
  IMO,
  GET_HISOTY,
  GET_LIVE_MONITORING,
  POST_LIVE_MONITORING,
  PLAYGROUND,
  GET_MONITORING_ALERT_CAMERA,
  GET_RECORD_BY_ALARM_ID,
  TEST_GET_RECORD_BY_ALARM_ID,
  GET_METTAX_TOKEN,
  METTAX_LIVE_CAM,
  METTAX_ALERT_LIST,
  POST_CALIBRATE,
  GET_VEHICLE_RITASE,
  POST_VEHICLE_COMMAND,
  METTAX_PLAYBACK,
  METTAX_PLAYBACK_LIST,
  METTAX_ALERT_BY_ALARMID,
  METTAX_TALK_PLUS,
  LIVE_TRACKING,
  LIVE_TRACKING_AUTH,
} from '../constant'
import axios from 'axios'
import * as REPO from '../helper/main'

const localKey = 'token'
// const id = JSON.parse(localStorage.getItem('userInfo'))
//   ? JSON.parse(localStorage.getItem('userInfo')).id
//   : null

export const postCalibrate = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(POST_CALIBRATE, body, config_token)
}

export const getMettaXToken = () => {
  return axios.post(GET_METTAX_TOKEN, {
    apiKey: '7gpLVWDA07',
    apiSecret: 'A0hRCgB8V52hOoIQ7YOh',
  })
}

export const mettaXLiveCamera = (token, body) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  }
  return axios.post(METTAX_LIVE_CAM, body, config_token)
}

export const mettaXAlertList = (token, body) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  }
  return axios.post(METTAX_ALERT_LIST, body, config_token)
}

export const mettaXAlertByAlarmId = (token, body) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  }
  return axios.post(METTAX_ALERT_BY_ALARMID, body, config_token)
}

export const mettaXPlaybackList = (token, body) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  }
  return axios.post(METTAX_PLAYBACK_LIST, body, config_token)
}

export const mettaXPlayback = (token, body) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  }
  return axios.post(METTAX_PLAYBACK, body, config_token)
}
 export const mettaXTalkPlus = (token,body)=>{
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: token,
    },
  }
  return axios.post(METTAX_TALK_PLUS, body, config_token)
 }
export const testGetRecordByAlarmId = (id, body) => {
  // let config_token = {
  //   headers: REPO.getAuthHeader(),
  // }

  let param = REPO.bikinParam(body)
  return axios.get(TEST_GET_RECORD_BY_ALARM_ID + '?' + param)
}

export const getRecordByAlarmId = (body) => {
  // let config_token = {
  //   headers: REPO.getAuthHeader(),
  // }

  let param = REPO.bikinParam(body)
  return axios.get(GET_RECORD_BY_ALARM_ID + '?' + param)
}

export const getMonitoringAlertCamera = (body) => {
  // let config_token = {
  //   headers: REPO.getAuthHeader(),
  // }

  let param = REPO.bikinParam(body)
  return axios.get(GET_MONITORING_ALERT_CAMERA + '?' + param)
}

export const getListVehicleClustering = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(LIST_VEHICLE_CLUSTER + id, config_token)
}

export const getFilterParamMonitoring = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(FILTER_PARAM + id, config_token)
}

export const subscribeVehicle = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(SUBSCRIBE_VEHICLE + id, config_token)
}

export const getOneMWMapping = (id, type = null) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(GET_ONE_MW_MAPPING + id + '/' + type, config_token)
}

export const unsubscribeVehicle = (id) => {
  //
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(UNSUBSCRIBE_VEHICLE + id, config_token)
}

export const getFilterCluster = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  //
  let param = REPO.bikinParam(body)
  return axios.get(CLUSTER_FILTER + param, config_token)
}

export const getRitase = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }

  const param = REPO.bikinParam(body)
  return axios.get(GET_VEHICLE_RITASE + id + '?' + param, config_token)
}

export const getRitaseDetail = (vid, id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }

  return axios.get(GET_VEHICLE_RITASE + vid + '/' + id, config_token)
}

export const postVehicleCommand = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(POST_VEHICLE_COMMAND, body, config_token)
}

export const getPlayback = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  //
  let param = REPO.bikinParam(body)
  return axios.get(PLAYBACK + param, config_token)
}
export const getVehicleTrip = (id, body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  //
  let param = REPO.bikinParam(body)
  return axios.get(GET_VEHICLE_TRIP + id + '?' + param, config_token)
}
export const getOneDetail = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }

  return axios.get(GET_HISOTY + id, config_token)
}
export const getPlaybackWebView = (body, token) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }
  let param = REPO.bikinParam(body)
  return axios.get(PLAYBACK + param, config_token)
}
export const getFilterClusterLicVin = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(FILTER_LIC_VIN_IMEI + id, config_token)
}
export const getLicenseByFleetList = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  const param = REPO.unencodedParam(body)
  // serialized the param to be not encoded
  return axios.get(LICENSE_BY_FLEET + '?' + param, config_token)
}
export const postFilterLicense = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(FILTER_LICENSE, body, config_token)
}
// Create IMO
export const postImo = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(IMO, body, config_token)
}

export const getImo = (id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(IMO + '?vehicle_id=' + id, config_token)
}

export const getLiveMonitoring = (token) => {
  let config_token = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  }
  return axios.get(GET_LIVE_MONITORING + token, config_token)
}

export const postLiveMonitoring = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(POST_LIVE_MONITORING, body, config_token)
}

export const postPlayground = (body) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.post(PLAYGROUND, body, config_token)
}

export const getLastPosition = (token) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(`${LIVE_TRACKING}?id=${token}`, config_token)
}

export const getLastPositionAuth = (vehicle_id) => {
  let config_token = {
    headers: REPO.getAuthHeader(),
  }
  return axios.get(`${LIVE_TRACKING_AUTH}?id=${vehicle_id}`, config_token)
}